module.exports = __webpack_public_path__ + "img/DSC_0010.922b8d5a.jpg";